<template>
  <div :class="containerClass">
    <div class="form-floating" v-if="inputType != 'password'">
      <input
        ref="inputControl"
        :id="ID"
        :placeholder="inputPlaceHolder"
        :type="
          inputType == 'intNumber' || inputType == 'floatNumber'
            ? 'text'
            : inputType
        "
        :disabled="disableInput"
        class="form-control"
        :class="inputComputed"
        :value="displayValue"
        @input="onInput($event)"
        @paste="onPasteHandler"
        @keypress="
          inputType == 'intNumber' || inputType == 'floatNumber'
            ? inputKeyPress($event)
            : ''
        "
        :maxlength="hasMaxLength ? maxLength : undefined"
      />
      <label :for="ID" :class="labelClass">{{ labelValue }}</label>
    </div>

    <!-- Password with showing value -->
    <div class="input-group-over" v-if="inputType == 'password'">
      <div class="form-floating">
        <input
          ref="inputControl"
          :id="ID"
          :placeholder="inputPlaceHolder"
          :type="inputType"
          :disabled="disableInput"
          class="form-control"
          :class="inputComputed"
          :value="inputValue"
          @input="onInput($event)"
          :maxlength="hasMaxLength ? maxLength : undefined"
        />
        <label :for="ID" :class="labelClass">{{ labelValue }}</label>
      </div>

      <button
        class="btn smaller btn-password-type-toggle js-form_advanced_type_toggle"
        data-target="#signup_password"
        @click="ShowPassword"
      >
        <span class="group-icon">
          <svg
            v-if="!isShownPassword"
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            :fill="iconColor"
            class="bi bi-eye-fill"
            viewBox="0 0 16 16"
          >
            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"></path>
            <path
              d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
            ></path>
          </svg>
          <svg
            v-if="isShownPassword"
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            :fill="iconColor"
            class="bi bi-eye-slash-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"
            ></path>
            <path
              d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"
            ></path>
          </svg>
          <!-- <i class="fi fi-close m-0" v-if="isShownPassword"></i> -->
        </span>
      </button>
    </div>
    <div>
      <p
        class="text-secondary"
        v-if="digitTranslate != '' && showTraslateOnButton"
      >
        <small>
          {{ digitTranslate }}
        </small>
      </p>
      <span
        v-if="
          maxSpaceTextArea != 0 ? showMessageDynamic : showMessage || !validated
        "
        :class="erroMessageClass"
        >{{ errorMessage }}</span
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      digitTranslate: '',
      displayValue: '',
      isShownPassword: false,
      validated: true,
      passwordIcon: 'eye-slash',
      showMessageDynamic: false,
      persianNumbers: [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers: [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ],
    };
  },
  props: {
    showTraslateOnButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxSpaceTextArea: {
      type: Number,
      required: false,
      default: 0,
    },
    ID: {
      type: String,
      required: false,
      default: null,
    },
    disableInput: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDigiTranslate: {
      type: Boolean,
      required: false,
      default: false,
    },
    digitSepratorChar: {
      type: String,
      required: false,
      default: ',',
    },
    iconColor: {
      type: String,
      required: false,
      default: '#506690',
    },
    floatPointChar: {
      type: String,
      required: false,
      default: ',',
    },
    isDigitSeprator: {
      type: Boolean,
      required: false,
      default: false,
    },

    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    labelClass: {
      type: String,
      required: false,
      default: '',
    },
    labelValue: {
      type: String,
      required: false,
      default: '',
    },
    iconSpin: {
      type: Boolean,
      default: false,
      required: false,
    },
    inputPlaceHolder: {
      type: String,
      required: false,
      default: '',
    },
    inputType: {
      type: String,
      required: false,
      default: 'text',
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    containerClass: {
      type: String,
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
    erroMessageClass: {
      type: String,
      required: false,
      default: 'text-danger',
    },

    showMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    inputValue: {
      type: [String, Number],
      required: false,
      default: '',
    },

    hasMaxLength: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
    },
  },
  computed: {
    inputComputed() {
      return `${this.inputClass}  ${!this.validated ? 'isNotValid' : ''} `;
    },
  },
  methods: {
    ShowPassword() {
      if (this.$refs.inputControl.type === 'password') {
        this.$refs.inputControl.type = 'text';
      } else {
        this.$refs.inputControl.type = 'password';
      }
      this.isShownPassword = !this.isShownPassword;
    },
    onPasteHandler(event) {
      let pasteData = event.clipboardData.getData('Text');
      if (this.inputType === 'intNumber') {
        pasteData = this.toEnglishNumbers(pasteData);
        if (isNaN(Number(pasteData))) {
          event.preventDefault();
          return false;
        }
      }
    },

    updateValues(newValue) {
      //----------------------- Set display value of input
      if (
        this.isDigitSeprator &&
        (this.inputType == 'intNumber' || this.inputType == 'floatNumber')
      ) {
        newValue
          ? (this.$data.displayValue = thousandSeprator(
              newValue,
              this.digitSepratorChar,
              this.floatPointChar
            ))
          : (this.$data.displayValue = '');
        if (this.showDigiTranslate)
          this.digitTranslate = numberToWord(newValue);
      } else {
        this.$data.displayValue = newValue;
      }
    },
    toEnglishNumbers(str) {
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str
            .replace(this.persianNumbers[i], i)
            .replace(this.arabicNumbers[i], i);
        }
      }
      return str;
    },
    onInput(event) {
      let valueWithOutSep = event.target.value;
      if (this.isDigitSeprator) {
        event.target.value = this.toEnglishNumbers(valueWithOutSep);
        valueWithOutSep = removeSeprator(event.target.value);
      }
      //----------------------- Update inputValue property
      this.$emit('update:inputValue', valueWithOutSep);

      //----------------------- Update digitTranslate property when showDigitTranslate enabled
      if (this.showDigiTranslate) {
        this.digitTranslate = numberToWord(valueWithOutSep);
      }

      this.validated = true;
    },
    // Handle number and value typing ↓
    inputKeyPress(event) {
      // int number condition ↓
      if (this.inputType === 'intNumber') {
        if (
          !(
            (event.which >= 48 && event.which <= 57) ||
            (event.which >= 1776 && event.which <= 1785)
          )
        ) {
          event.preventDefault();
          return;
        }
      }

      // float number condition ↓
      if (this.inputType === 'floatNumber') {
        if (
          (event.which != 46 || event.target.value.indexOf('.') != -1) &&
          !(
            (event.which >= 48 && event.which <= 57) ||
            (event.which >= 1776 && event.which <= 1785)
          )
        ) {
          event.preventDefault();
          return;
        }
      }
    },
    setFocus() {
      this.$refs.inputControl.focus();
    },
    showErrorMessage() {
      this.validated = false;
    },
    hideErrorMessage() {
      this.validated = true;
    },
  },
  watch: {
    inputValue: function (newValue) {
      this.updateValues(newValue);
    },
  },
  mounted() {
    this.updateValues(this.inputValue);
    if (this.inputType == 'password' && this.hasLeftBox) {
      document.getElementById(this.ID + 'icon').style.cursor = 'pointer';
    }
  },
  updated() {},
};
</script>

<style scoped></style>
